import { render, staticRenderFns } from "./AdminMindbody.vue?vue&type=template&id=dffab428&scoped=true&"
import script from "./AdminMindbody.vue?vue&type=script&lang=js&"
export * from "./AdminMindbody.vue?vue&type=script&lang=js&"
import style0 from "./AdminMindbody.vue?vue&type=style&index=0&id=dffab428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffab428",
  null
  
)

export default component.exports